import { render, staticRenderFns } from "./noPageFound.vue?vue&type=template&id=1b9ce9d7&"
import script from "./noPageFound.vue?vue&type=script&lang=js&"
export * from "./noPageFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports